import Vue from "vue";
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale';
import 'element-ui/packages/theme-chalk/lib/select.css';
import VuejsModal from 'vue-js-modal';

Vue.use(VuejsModal, { dialog: true });

import {
    Select,
    Option
} from 'element-ui';

const elements = [
    Select,
    Option
];

locale.use(lang);

elements.forEach(El => Vue.use(El, { locale } ));